'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { type ComponentProps, Suspense } from 'react';
const FooterSwiperInner = dynamic(() => import('./FooterSwiper'), {
  ssr: false
});
type FooterSwiperProps = ComponentProps<typeof FooterSwiperInner>;
export const FooterSwiper = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense fallback={null}><FooterSwiperInner {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};